/*
 * Copyright (c) 2022-2023. Haodong JU
 */

import IKDataEntity from '@/plugins/EntityFrameWork/IKDataEntity'
import hillo from 'hillo'
import GlobalSettings, { getRootUrl } from '@/model/global/GlobalSettings'

const entity = {
  id: {
    type: IKDataEntity.Types.Integer,
    displayName: 'id',
    tableConfig: {
      align: 'start'
    },
    form: false
  },
  image: {
    type: IKDataEntity.Types.Image,
    formConfig: {
      type: {
        root: () => getRootUrl() + GlobalSettings.bannerImageRoot
      },
      required: false
    },
    displayName: 'image'
  },
  sort: {
    type: IKDataEntity.Types.Integer,
    formConfig: {
      // required: true,
    }
  },
  remark: {
    type: IKDataEntity.Types.String,
    displayName: 'note',
    formConfig: {
      required: false
    }
  }
}
const config = {
  add: function (item) {
    return hillo.postWithUploadFile('Restaurant.php?op=addGiraffeBannerImage', {
      ...item
    }, { showLoading: true })
  },
  edit: function (item) {
    // if (!item.bannerImage) { item.bannerImage = item.bannerImage.split('/')[1] }

    return hillo.postWithUploadFile('Restaurant.php?op=updateGiraffeBannerImage', {
      ...item,
      params: JSON.stringify(item)
    }, {
      showLoading: false,
      silent: true
    })
  },
  remove: function (id) {
    return hillo.post('Restaurant.php?op=deleteGiraffeBannerImage', { id })
  },
  load: async function () {
    return (await hillo.get('Restaurant.php?op=showGiraffeBannerImage', {}))
      .content
  }
}

export default IKDataEntity.ModelFactory(entity, config)
